import { FormItemProps } from "antd";
import { ruleInnIndividual } from "./RulesConstantsApplication";
import { rulePhoneLength, ruleRequired } from "./RulesConstantsForms";
import { ruleAddress } from "./RulesConstantsUser";
import { validateDate } from "../../utils/utilities/ValidateDate";
import { ValidateFormErrorMessages } from "../validateFormErrorMessages";

export const formTextRules = [ruleRequired, ruleAddress];
export const formNumberRules = [ruleRequired, ruleInnIndividual];
export const formPhoneRules = [rulePhoneLength, ruleRequired];
export const formEmailTypeRules: FormItemProps["rules"] = [
  {
    type: "email",
    message: ValidateFormErrorMessages.enterCorrectEmail,
  },
  ruleRequired,
];

export const formDateRules: FormItemProps["rules"] = [
  ruleRequired,
  ({ getFieldValue }) => ({
    validator(_, value) {
      const fieldValue = getFieldValue("start_bg_at");
      const inputValue = new Date(value);

      return validateDate({ fieldValue, inputValue });
    },
  }),
];
